export const vacationPeriodEventNames = {
  pageViewed: "vacation period viewed"
};
